import React, {useEffect, useState} from "react";
import {thesisExpiring} from "../../../DataTypes/Models/Thesis/Thesis";
import {Card, CardContent, CardHeader} from "@material-ui/core";
import {Link} from "react-router-dom";

export default function InstructorThesisExpiring() {

    const [theses, setTheses] = useState([]);
    const [thesesLoaded, setThesesLoaded] = useState(false);

    useEffect(() => {
        if (!thesesLoaded) {
            setThesesLoaded(true);
            thesisExpiring().then( res => {
                setTheses(res)
            })
        }
    })

    return (
        <div style={{margin: "10px"}}>
            <Card>
                <CardHeader
                    title="Διατριβές που η εκδήλωση ενδιαφέροντως τελειώνει εντός της επόμενης εβδομάδας"
                />
                <CardContent>
                    {
                        theses.length === 0 || !Array.isArray(theses) ?
                            "Καμία διατριβή δεν λήγει εντός μιας εβδομάδας" :
                            <ul>
                                {
                                    theses.map( thesis => {
                                        return <li>
                                            <Link
                                                to={{
                                                    pathname: `/dashboard/instructor/thesis/single/${thesis.thesisID}`
                                                }}
                                            >
                                                {thesis.thesisTitle}
                                            </Link>
                                        </li>
                                    })
                                }
                            </ul>
                    }
                </CardContent>
            </Card>
        </div>
    )
}